import React, { useState, useContext } from "react";

import PlusIcon from "../../icons/plus-icon";
import FeesIcon from "../../icons/fees-icon";
import BalanceIcon from "../../icons/balance-icon";

import { PopUpContext } from "../../contexts/popUpContext";

import lbl from "../../data/Labels.json";
import LoanIcon from "../../icons/loan-icon";

const FabButtons = ({ cache }) => {
  const [open, setOpen] = useState(false);
  const { togglePopUp } = useContext(PopUpContext);

  return (
    <div className={`fab-container ${open ? "active" : ""}`} style={{width: open ? "230px" : "80px"}}>
      <button
        className="secondary"
        onClick={() => togglePopUp({ form: "creditor-balance-form", cache })}
      >
        <BalanceIcon />
        <span>{lbl.OpeningBalance}</span>
      </button>
      <button
        className="secondary"
        onClick={() =>
          togglePopUp({ form: "creditor-debt-payment-form", cache })
        }
      >
        <FeesIcon />
        <span>{lbl.Payment}</span>
      </button>
      <button
        className="secondary"
        onClick={() => togglePopUp({ form: "creditor-debt-form", cache })}
      >
        <LoanIcon />
        <span>{lbl.SaveDebt}</span>
      </button>
      <button className="primary" onClick={() => setOpen(!open)}>
        <PlusIcon />
        <span>{lbl.Cancel}</span>
      </button>
    </div>
  );
};

export default FabButtons;
